export default {
  props: {
    item: Object // first line text, second line text
  }
}
